import api from "../api";
import {ElMessage} from "element-plus";

export default {
    namespaced: true,
    state: {
        penalty_settings: {data: [], current_page: 1, total: 0, per_page: 10},
        loading: false,
        errors: {
            data: {
                errors: {
                    rate: [],
                    due_date: [],
                    effective_date: [],
                    project_id: []
                }
            }
        },
        has_errors: false,
        dialogVisible: false,
    },
    getters: {
        loading: state => state.loading,
        dialogVisible: state => state.dialogVisible,
        penalty_settings: state => state.penalty_settings,
        errors: state => state.errors,
        has_errors: state => state.has_errors,
    },
    mutations: {
        setLoading(state, val) {
            state.loading = val
        },
        setDialogVisible(state, status) {
            state.dialogVisible = status;
        },
        setPenaltySettings(state, data) {
            state.penalty_settings = data;
        },
        setErrors(state, errors) {
            state.errors = errors
        },
        hasErrors(state, val) {
            state.has_errors = val
            if (!val) {
                state.errors = {
                    data: {
                        errors: {
                            rate: [],
                            due_date: [],
                            effective_date: [],
                            project_id: []
                        }
                    }
                };
            }
        }
    },
    actions: {
        async openDialogVisible({commit}, status) {
            commit('setDialogVisible', status);
        },

        async getPenaltySettings({commit}, filters) {
            try {
                commit('activateLoading', 'penalty_setting/list', {root: true});
                const response = await api.getPenaltySettings(filters);
                commit('setPenaltySettings', response);
                commit('deactivateLoading', 'penalty_setting/list', {root: true});
            } catch (e) {
                ElMessage.error(e.response.data.message);
            }
        },
        async createPenaltySetting({dispatch, commit}, data) {
            try {
                commit('setLoading', true)
                commit('hasErrors', false)
                await api.createPenaltySetting(data);
                dispatch('getPenaltySettings', {
                    paginate: true
                })
                ElMessage.success('Penalty Setting created successfully!');
                commit('setLoading', false)
                commit('setDialogVisible', false)
            } catch (e) {
                commit('setLoading', false)
                commit('hasErrors', true)
                commit('setErrors', e.response)
                ElMessage.error(e.response.data.message);
            }
        },
        async editPenaltySetting({dispatch, commit}, data) {
            try {
                commit('setLoading', true)
                commit('hasErrors', false)
                await api.editPenaltySetting(data);
                dispatch('getPenaltySettings', {
                    paginate: true
                });
                ElMessage.success('Information updated successfully.');
                commit('setLoading', false)
                commit('setDialogVisible', false)
            } catch (e) {
                commit('setLoading', false);
                commit('hasErrors', true)
                commit('setErrors', e.response)
                ElMessage.error(e.response.data.message);
            }
        },

        async deletePenaltySetting({dispatch}, data) {
            try {
                const response = await api.deletePenaltySetting(data);
                dispatch('getPenaltySettings', {
                    paginate: true
                })
                if (response.status === 401) {
                    ElMessage.warning({
                        message: response.message,
                        duration: 10000
                    });
                } else {
                    ElMessage.success({
                        message: response.message,
                        duration: 10000
                    });
                }
            } catch (e) {
                if (e.response.status === 422) {
                    ElMessage.error(e.response.data.message)
                } else {
                    ElMessage.error('Error deleting Penalty Setting');
                }
            }
        }
    }
}
